import type { ReactNode } from 'react';
import { useActiveOrg } from './active-org-context';

/** Remount feature-page state when the active organization changes. */
export function OrgScopedBoundary({ children }: { children: ReactNode }) {
  const { activeCharityId } = useActiveOrg();
  return <div key={activeCharityId ?? 'none'}>{children}</div>;
}
